<template>
	<!-- 工作台 -->
	<div class="mod-config">
		<el-row>
			<!-- <el-col :span="1" style="border:1px solid transparent">
			</el-col> -->
			<el-col :span="24" class="set_top">
				<el-col :span="20" style="border:1px solid transparent"></el-col>
				<el-col :span="2">
					<i class="el-icon-s-operation" @click="selectProjects()">项目切换</i>
				</el-col>
				<el-col :span="2">
					<i class="el-icon-switch-button" @click="logOut()">退出</i>
				</el-col>
			</el-col>
		</el-row>
		<el-row style="margin-top:30px;">
			<!-- <el-col :span="1" style="border:1px solid transparent">
			</el-col> -->
			<el-col :span="13">
				<el-row class="set_title">
					<div class="set_title_div">
						项目信息
					</div>
				</el-row>
				<div class="set_div">
					<el-row>
						<el-col :span="22">
							<el-form :model="infoName" ref="infoName" label-width="115px" :inline="true"
								class="border-form" style="margin:10px 25px 20px 30px;background-color:white">
								<el-row class="set_border">
									<el-col :span="24">
										<el-form-item label="工作控制号" class="item">
											{{ infoName.workNo }}
										</el-form-item>
									</el-col>
								</el-row>
								<el-row class="set_border">
									<el-col :span="24">
										<el-form-item label="项目名称" class="item">
											{{ infoName.projectName }}
										</el-form-item>
									</el-col>
								</el-row>
								<el-row class="set_border">
									<el-col :span="24">
										<el-form-item label="项目总监" class="item">
											{{ infoName.projectDirector }}
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</el-col>
					</el-row>
				</div>
			</el-col>
			<el-col :span="1" style="border:1px solid transparent">
			</el-col>
			<el-col :span="11">
				<el-row class="set_noclose_title">
					<div class="set_title_div">
						未封闭项
					</div>
				</el-row>
				<div class="set_noclose_div">
					<el-row style="margin-bottom:8px">
						<el-col :span="8">
							<div class="roundBox1 roundBox01" v-if="noCloseCount.problemSource > 0">
								<div @click="moreInspection('0')">{{ noCloseCount.problemSource }}</div>
							</div>
							<div class="roundBox1 roundBox01" v-else>
								<div>{{ noCloseCount.problemSource }}</div>
							</div>
							<div class="roundText">巡检</div>
						</el-col>
						<el-col :span="8">
							<div class="roundBox1 roundBox02" v-if="noCloseCount.problemState > 0">
								<div @click="moreInformation('1')">{{ noCloseCount.problemState }}</div>
							</div>
							<div class="roundBox1 roundBox02" v-else>
								<div>{{ noCloseCount.problemState }}</div>
							</div>
							<div class="roundText">报验</div>
						</el-col>
						<el-col :span="8">
							<div class="roundBox1 roundBox03" v-if="noCloseCount.contact > 0">
								<div @click="moreContact('0')">{{ noCloseCount.contact }}</div>
							</div>
							<div class="roundBox1 roundBox03" v-else>
								<div>{{ noCloseCount.contact }}</div>
							</div>
							<div class="roundText">联系单</div>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px;">
			<!-- <el-col :span="1" style="border:1px solid transparent">
			</el-col> -->
			<el-row class="set_node_title">
				<div style="padding-bottom:3px;width:300px;font-weight: bolder;">
					项目合同工期与具体节点计划及执行情况
				</div>
			</el-row>
			<el-row class="conode">
				<div>
					<el-col :span="8">
						<el-table ref="setConodeList" row-key="recNo" class="setConodeList" :data="contractDurationList"
							header-align="center" border style="width: 98%;margin-top:20px;margin-left:5px"
							header-cell-class-name="dataListTHeader" :cell-style="tableConodeCellStyle">
							<el-table-column prop="subjectName" label=" " width="" align="center"></el-table-column>
							<el-table-column prop="deliverDate" label="合同工期" width="" align="center"></el-table-column>
							<el-table-column prop="remark" label="备注" align="center"></el-table-column>
						</el-table>
					</el-col>
					<el-col :span="16">
						<el-table max-height="600" :span-method="objectSpanMethod" border ref="setNodeList"
							class="setNodeList" :data="nodeList" header-align="center"
							header-cell-class-name="dataListTHeader" :cell-style="tableNodeCellStyle"
							style="margin: 20px;width:97%">
							<el-table-column v-for="(v, idx) in headers" :key="idx"
								v-if="headers != undefined && headers.length > 0 && v.nodeId === '0'"
								:label="v.nodeName" :prop="v.nodeId" align="center" width="130px">
								<template slot-scope="scope">
									<span style="font-weight:bolder">
										{{ scope.row.subjectName }}
									</span>
								</template>
							</el-table-column>
							<el-table-column v-for="(v, idx) in headers" :key="idx"
								v-if="headers != undefined && headers.length > 0 && v.nodeId === '1'"
								:label="v.nodeName" :prop="v.nodeId" align="center" width="60px">
								<template slot-scope="scope">
									<span style="font-weight:bolder">
										{{ scope.row.title }}
									</span>
								</template>
							</el-table-column>
							<el-table-column v-for="(v, idx) in headers" :key="idx"
								v-if="headers != undefined && headers.length > 0 && idx > 1" :label="v.nodeName"
								:prop="v.nodeId" align="center">
								<template slot-scope="scope">
									<span>
										{{ scope.row.contentList[idx - 2].colValue }}
									</span>
								</template>
							</el-table-column>
							<el-table-column align="left" label="" v-if="headers != undefined && headers.length == 2">
							</el-table-column>
						</el-table>
					</el-col>
				</div>
			</el-row>
		</el-row>
		<el-row style="margin-top: 10px;">
			<!-- <el-col :span="1" style="border:1px solid transparent">
			</el-col> -->
			<el-col :span="24">
				<el-row class="set_work_title">
					<div style="padding-bottom:3px;width:127px;font-weight: bolder;">
						相关工作及文件
					</div>
				</el-row>
				<div class="set_work_div">
					<el-row>
						<span class="setff" v-if="webmoduleshow.weekreportFlg == '1'">
							<div class="roundBox roundBox07" v-if="infoCount.week > 0">
								<div @click="moreWeekly()">{{ infoCount.week }}</div>
							</div>
							<div class="roundBox roundBox07" v-else>
								<div>{{ infoCount.week }}</div>
							</div>
							<div class="roundText">周报</div>
						</span>
						<span class="setff" v-if="webmoduleshow.monthreportFlg == '1'">
							<div class="roundBox roundBox06" v-if="infoCount.month > 0">
								<div @click="moreMonthly()">{{ infoCount.month }}</div>
							</div>
							<div class="roundBox roundBox06" v-else>
								<div>{{ infoCount.month }}</div>
							</div>
							<div class="roundText">月报</div>
						</span>
						<span class="setff" v-if="webmoduleshow.dayreportFlg == '1'">
							<div class="roundBox roundBox08" v-if="infoCount.daily > 0">
								<div @click="moreDaily()">{{ infoCount.daily }}</div>
							</div>
							<div class="roundBox roundBox08" v-else>
								<div>{{ infoCount.daily }}</div>
							</div>
							<div class="roundText">日报</div>
						</span>
						<span class="setff" v-if="webmoduleshow.specialreportFlg == '1'">
							<div class="roundBox roundBox03" v-if="infoCount.specialReport > 0">
								<div @click="moreSpecialReport()">{{ infoCount.specialReport }}</div>
							</div>
							<div class="roundBox roundBox03" v-else>
								<div> {{ infoCount.specialReport }} </div>
							</div>
							<div class="roundText">专题报告</div>
						</span>
						<span class="setff" v-if="webmoduleshow.finishworkFlg == '1'">
							<div class="roundBox roundBox02" v-if="infoCount.finishFile > 0">
								<div @click="moreFinishFiles()">{{ infoCount.finishFile }}</div>
							</div>
							<div class="roundBox roundBox02" v-else>
								<div> {{ infoCount.finishFile }} </div>
							</div>
							<div class="roundText">完工资料</div>
						</span>
						<span class="setff" v-if="webmoduleshow.contactFlg == '1'">
							<div class="roundBox roundBox05" v-if="infoCount.contact > 0">
								<div @click="moreContact('')">{{ infoCount.contact }}</div>
							</div>
							<div class="roundBox roundBox05" v-else>
								<div>{{ infoCount.contact }}</div>
							</div>
							<div class="roundText">联系单</div>
						</span>
						<span class="setff" v-if="webmoduleshow.noticeFlg == '1'">
							<div class="roundBox roundBox04" v-if="infoCount.notice > 0">
								<div @click="moreNotice()">{{ infoCount.notice }}</div>
							</div>
							<div class="roundBox roundBox04" v-else>
								<div>{{ infoCount.notice }}</div>
							</div>
							<div class="roundText">通知单</div>
						</span>
						<span class="setff" v-if="webmoduleshow.inspectionFlg == '1'">
							<div class="roundBox2 roundBox10">
								<!-- <div @click="moreInspection('')">{{ infoCount.problemSource }}</div> -->
								<div>{{ infoCount.problemSource }}</div>
							</div>
							<div class="roundText">巡检</div>
						</span>
						<span class="setff" v-if="webmoduleshow.testFlg == '1'">
							<div class="roundBox2 roundBox08">
								<!-- <div @click="moreInformation('')">{{ infoCount.problemState }}</div> -->
								<div>{{ infoCount.problemState }}</div>
							</div>
							<div class="roundText">报验</div>
						</span>
						<span class="setff" v-if="webmoduleshow.onsiteFlg == '1'">
							<div class="roundBox2 roundBox07">
								<!-- <div @click="moreStation()">{{ infoCount.monitor }}</div> -->
								<div>{{ infoCount.monitor }}</div>
							</div>
							<div class="roundText">旁站</div>
						</span>
						<!-- <span class="setff">
							<div class="roundBox roundBox00"> -->
						<!-- <div @click="moreExamination()">{{ infoCount.exa }}</div> -->
						<!-- <div>{{ infoCount.exa }}</div>
							</div>
							<div class="roundText">文件审查</div>
						</span> -->
						<span class="setff" v-if="webmoduleshow.safetyFlg == '1'">
							<div class="roundBox roundBox03" v-if="infoCount.safety > 0">
								<div @click="moreSafety()">{{ infoCount.safety }}</div>
							</div>
							<div class="roundBox roundBox03" v-else>
								<div> {{ infoCount.safety }} </div>
							</div>
							<div class="roundText">安全监督记录</div>
						</span>
						<span class="setff" v-if="webmoduleshow.contractFlg == '1'">
							<div class="roundBox2 roundBox00">
								<!-- <div @click="moreContract()">{{ infoCount.contract }}</div> -->
								<div>{{ infoCount.contract }}</div>
							</div>
							<div class="roundText">合同</div>
						</span>
						<span class="setff" v-if="webmoduleshow.meetFlg == '1'">
							<div class="roundBox2 roundBox00">
								<!-- <div @click="moreMeet()">{{ infoCount.meet }}</div> -->
								<div>{{ infoCount.meet }}</div>
							</div>
							<div class="roundText">会议</div>
						</span>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<el-row style="margin-top: 12px;">
			<el-col :span="10">
				<el-row class="set_node_title">
					<div class="set_title_div">
						质量巡检
					</div>
				</el-row>
				<div class="set_node_div">
					<el-row v-for="(inspection, index) in inspectionList" v-model="inspectionList">
						<el-col :span="24" class="set_sub"> {{ inspection.projectNo }}</el-col>
						<el-col :span="22" style="margin-left:20px">
							<el-table ref="workbenchList" class="workbenchList" :data="inspection.detailDtoList"
								header-align="center" :cell-style="tableCellStyle"
								header-cell-class-name="dataListTHeader" style="margin-bottom: 20px">
								<el-table-column label="" prop="majorName" width="" align="center">
								</el-table-column>
								<el-table-column label="提出整改项" prop="applyNum" width="" align="center">
								</el-table-column>
								<el-table-column label="整改完成项" prop="alreadyModifyNum" width="" align="center">
								</el-table-column>
								<el-table-column label="未完成项" prop="notFinishNum" width="" align="center">
									<!-- <template slot-scope="scope">
										<div style="color: red;"> {{ scope.row.notFinishNum }}</div>
									</template> -->
								</el-table-column>
								<el-table-column label="完成率" prop="finishRate" width="" align="center">
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</div>
			</el-col>
			<el-col :span="1" style="border:1px solid transparent;margin-right:10%">
			</el-col>
			<el-col :span="13">
				<el-row class="set_file_title">
					<div class="set_title_div">
						质量报验
					</div>
				</el-row>
				<div class="set_file_div">
					<el-row v-for="(testrecord, index) in testRecordList" :key="'test' +index" v-model="testRecordList">
						<el-col :span="24" class="set_sub"> {{
							testrecord.projectNo }}</el-col>
						<!-- <el-col :span="1" style="border:1px solid transparent;">
						</el-col> -->
						<el-col :span="23" style="margin-left:20px">
							<el-table ref="workbenchList" class="workbenchList" :data="testrecord.detailDtoList"
								header-align="center" :cell-style="tableCellStyle"
								header-cell-class-name="dataListTHeader" style="margin-bottom: 20px;;width:95%">
								<el-table-column label="" prop="majorName" width="" align="center">
								</el-table-column>
								<el-table-column label="报验" prop="testRecordNum" width="" align="center">
								</el-table-column>
								<el-table-column label="接受" prop="testConclusionNum" width="" align="center">
								</el-table-column>
								<el-table-column label="有条件接受" prop="testConclusionWhereNum" width="" align="center">
								</el-table-column>
								<el-table-column label="修正后复检" prop="recheckAfterCorrectionNum" width="" align="center">
								</el-table-column>
								<el-table-column label="不接受" prop="testConclusionRefuseNum" width="" align="center">
								</el-table-column>
								<el-table-column label="合格率" prop="testConclusionRate" width="" align="center">
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<el-dialog title="项目名称" :visible.sync="selectProjectVisible" class="dia" width="500px"
			:close-on-click-modal="true">
			<div style="padding: 5px 15px;">
				<div v-for="(project, index) in seletProjectList" :key="index" class="project-item"
					:title="project.projectName" @click="selectProjet(project.workNo)"
					@mouseenter="$event.target.style.background = '#f5f7fa'"
					@mouseleave="$event.target.style.background = ''">
					{{ project.projectName }}
				</div>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import $common from "@/utils/common.js"
export default {
	data() {
		return {
			showNodeMore: false,
			showPersonMore: false,
			showPersonSet: false,
			selectProjectVisible: false,
			infoList: [],
			noCloseCount: {},
			infoCount: {},
			infoName: {},
			category: {},
			jobList: [],
			setingPersonVisible: false,
			helpFileUrl: 'http://cs.ccsi.com.cn/upload/help/helpFile.pdf',
			menuList: [],
			subjectList: [],
			inspectionList: [],
			testRecordList: [],
			nodeList: [],
			headers: [],
			seletProjectList: [],
			contractDurationList: [],
			webmoduleshow: {}
		};
	},
	components: {
	},
	mounted() {
		this.workNo = $common.getItem("workNo")
		this.getSubjectDropDown()
	},
	methods: {
		selectProjet(workNo) {
			// 校验项目数据
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/validProjectData/" + workNo,
				method: "post",
				data: this.$http.adornData()
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.selectProjectVisible = false;
					sessionStorage.setItem('workNo', JSON.stringify(workNo))
					this.workNo = workNo;
					this.getSubjectDropDown()
				}
			});
		},
		selectProjects() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/getProjectListByRelationId",
				method: "get",
				data: this.$http.adornData()
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.selectProjectVisible = true;
					this.seletProjectList = data.body;
				}
			});
		},
		logOut() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/portaluser/logout",
				method: "get",
				data: this.$http.adornData()
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.visible = false;
							this.$router.replace({ name: "login" });
						}
					});

				}
			});
			// alert("退出")
		},
		getProjectInfoListByRelationId() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/getProjectInfoListByRelationId",
				method: "post",
				data: this.$http.adornData()
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
				}
			});
		},
		getProjectKind(kind) {
			if (kind === '1') {
				return '船舶监理'
			} else if (kind === '2') {
				return '设备监理'
			}
			return ''
		},
		getSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.subjectList = data.body;
					this.$store.commit('common/updateSubjectList', this.subjectList)
					if (this.subjectList.length != undefined && this.subjectList.length > 0) {
						if ($common.getItem("subjectNo") == "" || $common.getItem("subjectNo") == undefined) {
							$common.setItem("subjectNo", this.subjectList[0].displayValue);
							this.$store.commit('common/updateSelectSubjectNo', this.subjectNo)
						}
					}
					this.$emit('subMenuIndex', 0)
					this.showNodeMore = $common.isAuth('workbench:node.more');
					this.showPersonMore = $common.isAuth('workbench:person.more');
					this.showPersonSet = $common.isAuth('workbench:person.set');
					// this.getInfo();
					this.getWebModuleShowInfo()
					this.getInfoCount();
					this.getInfoName();
					// this.getInfoRemind();
					// this.selectCategory();
					// this.selectJob();
					this.getNoCloseCount();
					this.getTestRecordList();
					this.getInspectionList();
					// this.refreshNodeRecords();
					this.getNodeInfoList();
					this.getContractDurationList()
				}
				// }
			});
		},
		getWebModuleShowInfo() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/getWebModuleShowInfo/" + $common.getItem("workNo"),
				method: 'get',
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.webmoduleshow = data.body
				}
			})
		},
		getContractDurationList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/getContractDurationList/" + $common.getItem("workNo"),
				method: 'get',
				params: this.$http.adornParams({
				})
			}).then(({
				data
			}) => {
				if (data && data.code === 200) {
					this.contractDurationList = data.body.records;
				}
			})
		},
		getSubjectMenuIndex() {
			let rtn = 0
			this.menuList[0].list.forEach(function (item, idx) {
				if (item.routerName === '/subjectList') {
					rtn = idx
				}
			})
			return rtn
		},
		showHelpFile() {
			window.open(this.helpFileUrl);
		},
		siteContentViewHeight() {
			var height = this.$store.state.common.documentClientHeight - 50;
			return { height: height + 'px' }
		},
		projectUserListHeight() {
			var height = this.$store.state.common.documentClientHeight - 670;
			return { height: height + 'px' }
		},
		// getInfo() {
		// 	this.$http({
		// 		//   url:  this.$store.state.httpUrl + "/business/index/projectInfo/"+$common.getItem("workNo"),
		// 		url: this.$store.state.httpUrl + "/business/nodeinfo/getNodeInfo/" + $common.getItem("workNo"),
		// 		method: "get",
		// 		params: {},
		// 	}).then(({ data }) => {
		// 		if (data && data.code === 200) {
		// 			this.infoList = data.body;
		// 		}
		// 	});
		// },
		setingPersonHandle(id) {
			this.setingPersonVisible = true
			this.$nextTick(() => {
				this.$refs.setingPerson.init(id);
			})
		},
		goPage(type) {
			let _indexList = [];
			if (type == 1) {
				this.$router.push("/nodeList");
				_indexList = $common.getMenuIndex("/nodeList");
			} else {
				this.$router.push("/personnelCommun");
				_indexList = $common.getMenuIndex("/personnelCommun");
			}
			this.$parent.setMenuAllIndex(_indexList[0], _indexList[1]);
		},
		getNoCloseCount() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/noCloseCount/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.noCloseCount = data.body;
				}
			});
		},
		getInspectionList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/inspectioninfo/getInspectionList/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.inspectionList = data.body;
				}
			});
		},
		getTestRecordList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/getTestRecordList/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.testRecordList = data.body;
				}
			});
		},
		// 获取进度节点数据
		getNodeInfoList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectprogressnoderecord/list/" + $common.getItem("workNo"),
				method: 'get',
				params: this.$http.adornParams({
				})
			}).then(({
				data
			}) => {
				if (data && data.code === 200) {
					this.nodeList = data.body.records;
					this.headers = data.body.headers;
				}
			})
		},
		getInfoCount() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/infoCount/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.infoCount = data.body;
				}
			});
		},
		getInfoName() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/infoName/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.infoName = data.body;
					this.infoName.projectEntrust = this.infoName.projectEntrust.replaceAll(";", "<br/>");
					this.infoName.projectDesignCompany = this.infoName.projectDesignCompany.replaceAll(";", "<br/>");
					this.infoName.projectConstructionCompany = this.infoName.projectConstructionCompany.replaceAll(";", "<br/>");
				}
			});
		},
		moreInspection(closeState) {
			this.$router.push({ name: 'patrolList', query: { type: '1', closeState: closeState } });
		},
		moreInformation(closeState) {
			this.$router.push({ name: 'information', query: { type: '1', closeState: closeState } });
		},
		moreContact(closeState) {
			if (this.infoName.executedFile === '1') {
				this.$router.push({ name: 'contactdocument', query: {closeState: closeState } });
			} else {
				this.$router.push({ name: 'hqcontact', query: {closeState: closeState } });
			}
		},
		moreNotice() {
			if (this.infoName.executedFile === '1') {
				this.$router.push({ name: 'noticedocument' });
			} else {
				this.$router.push({ name: 'hqnotice' });
			}
		},
		moreStation() {
			this.$router.push({ name: 'stationList', query: { type: 1 } });
		},
		moreExamination() {
			this.$router.push({ name: 'examination' });
		},
		moreWeekly() {
			// 判断周报类型后跳转至对应页面
			if (this.infoName.executedFile === '1') {
				this.$router.push({ name: 'weekly' });
			} else {
				this.$router.push({ name: 'projectWeekly' });
			}
		},
		moreMonthly() {
			if (this.infoName.executedFile === '1') {
				this.$router.push({ name: 'monthly' });
			} else {
				this.$router.push({ name: 'projectMonthlyList' });
			}
		},
		moreDaily() {
			this.$router.push({ name: 'dailyList' });
		},
		moreSpecialReport() {
			this.$router.push({ name: 'specialreport' });
		},
		moreFinishFiles() {
			this.$router.push({ name: 'finishedFileList' });
		},
		moreSafety() {
			this.$router.push({ name: 'safetysupervisioninspectionList' });
		},
		moreContract() {
			this.$router.push({ name: 'ownerContract' });
		},
		moreMeet() {
			this.$router.push({ name: 'meetingList' });
		},
		tableRowClassName({ row, rowIndex }) {
			if (columnIndex == 1 || columnIndex == 0) {
				return 'background:#E1F1FF !important;padding: 0px;color: #00428E !important;font-size: 13px;font-weight:bold'
			} else {
				return 'padding: 0px'
			}
			return $common.tableScnenRowClassName({ row, rowIndex });
		},
		flitterSubjectNo(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.subjectName === arr[index - 1].subjectName) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		flitterData(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.title === arr[index - 1].title) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				// this.tableData  修改
				const _row = (this.flitterSubjectNo(this.nodeList).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			} else if (columnIndex === 1) {
				// this.tableData  修改
				const _row = (this.flitterData(this.nodeList).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			}
		},
		// 改变某一列单元格背景颜色
		tableCellStyle({ row, column, rowIndex, columnIndex }) {
			if (columnIndex == 0) {
				return 'background:#E1F1FF !important;padding: 0px;color: #00428E !important;font-size: 13px;font-weight:bold'
			} else {
				return 'padding: 0px'
			}
		},
		tableNodeCellStyle({ row, column, rowIndex, columnIndex }) {
			if (columnIndex == 1 || columnIndex == 0) {
				return 'background:#E1F1FF !important;padding: 0px;color: #00428E !important;font-size: 13px;font-weight:bold'
			} else {
				if (row.title === '实际') {
					return 'color:blue;padding: 0px'
				} else {
					return 'padding: 0px'
				}
			}
		},
		tableConodeCellStyle({ row, column, rowIndex, columnIndex }) {
			if (columnIndex == 0) {
				return 'background:#E1F1FF !important;padding: 0px;color: #00428E !important;font-size: 13px;font-weight:bold'
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.item::v-deep .el-form-item__label {
	color: #036EC2 !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	// background-color: #E1F1FF;
	white-space: nowrap !important;
	font-size: 16px !important;
	// border-right: solid #dadada 1px;
}

::v-deep .el-form-item {
	display: flex !important;
	align-items: stretch !important;
	margin-bottom: 0px !important;
	color: #036EC2 !important;
	// border-bottom: solid #dadada 1px;
}

::v-deep .el-form-item__content {
	line-height: 40px;
	position: relative;
	font-size: 16px;
}


.roundText {
	font-size: 16px;
	color: #1c1c1c;
	margin-top: 20px;
	margin-bottom: 10px;
	text-align: center;
}

.roundBox {
	width: 89px;
	height: 89px;
	margin: 15px auto;
	border-radius: 42px;
	box-shadow: 0 0 12px 0 rgb(74 133 253 / 30%);
	padding: 10px;
	box-sizing: border-box;
	cursor: pointer;

	div {
		width: 68px;
		height: 68px;
		border-radius: 36px;
		line-height: 68px;
		text-align: center;
		font-size: 22px;
		color: #ffffff;
		background: linear-gradient(to right, #4a85fe 0%, #78a4ff 100%);
	}
}

.roundBox1 {
	width: 130px;
	height: 78px;
	margin: 20px auto;
	border-radius: 5px;
	box-shadow: 0 0 12px 0 rgb(74 133 253 / 30%);
	padding: 8px;
	box-sizing: border-box;
	cursor: pointer;

	div {
		width: 110px;
		height: 60px;
		border-radius: 10px;
		line-height: 60px;
		text-align: center;
		font-size: 30px;
		font-weight: bolder;
		color: #ffffff;
		background: linear-gradient(to right, #4a85fe 0%, #78a4ff 100%);
	}
}

.roundBox2 {
	width: 89px;
	height: 89px;
	margin: 15px auto;
	border-radius: 42px;
	box-shadow: 0 0 12px 0 rgb(74 133 253 / 30%);
	// box-shadow: 0 0 12px 0 white;
	padding: 10px;
	box-sizing: border-box;
	// cursor: pointer;
	// display: inline-block;

	div {
		width: 68px;
		height: 68px;
		border-radius: 36px;
		line-height: 68px;
		text-align: center;
		font-size: 22px;
		color: white;
		background: linear-gradient(to right, #4a85fe 0%, #78a4ff 100%);
		display: inline-block;
	}
}

.roundBox02 {
	box-shadow: 0 0 12px 0 rgb(255 185 70 / 30%);

	div {
		background: linear-gradient(to right, #ffb946 0%, #ffc86e 100%);
	}
}

.roundBox00 {
	box-shadow: 10 10 12px 0 rgb(255 185 70 / 30%);

	div {
		background: linear-gradient(to right, rgb(198, 235, 224) 0%, rgb(198, 235, 224) 100%);
	}
}

.roundBox10 {
	box-shadow: 10 10 12px 0 rgb(255 185 70 / 30%);

	div {
		background: linear-gradient(to right, rgb(86, 151, 204) 0%, rgb(73, 161, 202) 100%);
	}
}

.roundBox01 {
	box-shadow: 10 10 12px 0 rgb(255 185 70 / 30%);

	div {
		background: linear-gradient(to right, #4e8ce9 0%, #4e8ce9 100%);
	}
}

.roundBox03 {
	box-shadow: 0 0 12px 0 rgb(208 97 204 / 30%);

	div {
		background: linear-gradient(to right, #78c5e4 0%, #72cfdb 100%);
	}
}

.roundBox04 {
	box-shadow: 0 0 12px 0 rgb(230 57 70 / 30%);

	div {
		background: linear-gradient(to right, #e63946 0%, #f3646f 100%);
	}
}


.roundBox05 {
	box-shadow: 0 0 12px 0 rgb(208 97 204 / 30%);

	div {
		background: linear-gradient(to right, #8ad8a8 0%, #9fdf84 100%);
	}
}

.roundBox06 {
	box-shadow: 0 0 12px 0 rgb(230 57 70 / 30%);

	div {
		background: linear-gradient(to right, #7ea3da 0%, rgb(65, 151, 231) 100%);
	}
}

.roundBox08 {
	box-shadow: 0 0 12px 0 rgb(230 57 70 / 30%);

	div {
		background: linear-gradient(to right, #4d945a 0%, rgb(49, 146, 93) 100%);
	}
}

.roundBox07 {
	box-shadow: 0 0 12px 0 rgb(230 57 70 / 30%);

	div {
		background: linear-gradient(to right, #da7ed2 0%, rgb(231, 65, 231) 100%);
	}
}

.bd {
	font-size: 15px;
	color: white;
	background-color: #036EC2;
	height: 40px;
	padding: 10px 0px 0px 20px;
	width: 100%;
	border-radius: 3% 0% 0% 0%;
}

.set_title {
	font-size: 16px;
	color: white;
	background-color: #036EC2;
	height: 40px;
	padding: 12px 0px 0px 30px;
	width: 90%;
	border-radius: 7px 7px 0% 0%;
	margin-bottom: -15px;
	margin-left: 15px;
}

.set_noclose_title {
	font-size: 16px;
	color: white;
	background-color: #036EC2;
	height: 40px;
	padding: 12px 0px 0px 30px;
	width: 95.6%;
	border-radius: 7px 7px 0% 0%;
	margin-bottom: -15px;
	margin-top: -1px;
	// margin-left:10px;
}

.set_top {
	font-size: 16px;
	color: white;
	background-color: #036EC2;
	height: 45px;
	padding: 12px 0px 0px 30px;
	width: 97%;
	border-radius: 7px 7px 0% 0%;
	margin-bottom: -15px;
	margin-left: 15px;
}

.set_node_title {
	font-size: 16px;
	color: white;
	background-color: #036EC2;
	height: 40px;
	padding: 12px 0px 0px 30px;
	width: 97.1%;
	border-radius: 7px 7px 0% 0%;
	margin-bottom: -15px;
	margin-left: 15px;
	margin-top: 3px;
}

.set_work_title {
	font-size: 16px;
	color: white;
	background-color: #036EC2;
	height: 40px;
	padding: 12px 0px 0px 30px;
	width: 97%;
	border-radius: 7px 7px 0% 0%;
	margin-bottom: -15px;
	margin-left: 15px;
}

.set_file_title {
	font-size: 16px;
	color: white;
	background-color: #036EC2;
	height: 40px;
	padding: 12px 0px 0px 30px;
	width: 100.8%;
	border-radius: 7px 7px 0% 0%;
	margin-bottom: -15px;
	margin-left: 30px;
}

.el-icon-d-arrow-right {
	font-size: 20px;
	color: rgb(58, 58, 190);
	font-weight: 800;
	cursor: pointer;
}

.node-container {
	display: flex;
	color: #1c1c1c;
}

.node-left-container {
	// border: 1px #DADADA solid;
	border-right: 0px;
	width: 70px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 20px;
}

.node-right-container {
	border-right: 1px #DADADA solid;
	border-bottom: 1px #DADADA solid;
	display: flex;
	flex-direction: column;
}

.node-right-container-row {
	display: flex;
}

.node-content-title1 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(211, 230, 248);
	height: 30px
}

.node-content-title2 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 30px
}

.node-content-title3 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(240, 240, 33);
	height: 30px
}

.node-content-body {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 120px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 30px
}

.node-content-body5 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 230px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 30px
}

.node-content-body1 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 120px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(211, 230, 248);
	height: 30px
}

.node-content-body4 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 230px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(211, 230, 248);
	height: 30px
}

.node-content-body3 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 120px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(240, 240, 33);
	height: 30px
}

.node-content-body6 {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 230px;
	height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgb(240, 240, 33);
	height: 30px
}

.node-content-title-container {
	display: flex;
}

.node-content-title-container-left {
	border: 1px #DADADA solid;
	border-right: 0px;
	border-bottom: 0px;
	width: 100px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #ebeae8;
}

.node-content-title-container-right {
	display: flex;
	flex-direction: column;
}

.node-content-title-container-right-row {
	display: flex;
	flex-direction: row;
	background-color: #ebeae8;
}

.set_div {
	border-radius: 3%;
	margin-top: 10px;
	margin-left: 15px;
	border: 1px solid #036EC2;
	background-color: white;
	width: 90%;
	border-radius: 0px 0px 7px 7px;
	height: 157px
}

.set_noclose_div {
	border-radius: 3%;
	margin-top: 10px;
	// margin-left:10px;
	border: 1px solid #036EC2;
	background-color: white;
	width: 95.6%;
	border-radius: 0px 0px 7px 7px;
}

.set_node_div {
	border-radius: 3%;
	margin-top: 10px;
	margin-left: 15px;
	border: 1px solid #036EC2;
	background-color: white;
	width: 97.1%;
	border-radius: 0px 0px 7px 7px;
}

.set_node_div1 {
	border-radius: 3%;
	margin-top: 10px;
	margin-left: 15px;
	border: 1px solid #036EC2;
	background-color: white;
	width: 97.1%;
	border-radius: 0px 0px 7px 7px;
}

.set_work_div {
	border-radius: 3%;
	margin-top: 10px;
	margin-left: 15px;
	border: 1px solid #036EC2;
	background-color: white;
	width: 97%;
	border-radius: 0px 0px 7px 7px;
	height: 159px
}

.set_file_div {
	border-radius: 3%;
	margin-top: 10px;
	margin-left: 30px;
	border: 1px solid #036EC2;
	background-color: white;
	width: 100.8%;
	border-radius: 0px 0px 7px 7px;
}

.mod-config {
	background-color: white !important;
}

.set_sub {
	font-weight: bolder;
	font-size: 16px;
	margin: 10px 25px;
}

.el-icon-s-operation:before {
	margin-right: 5px;
}

.el-icon-s-operation {
	cursor: pointer;
	margin-top: 3px;
}

.el-icon-switch-button:before {
	margin-right: 5px;
}

.el-icon-switch-button {
	cursor: pointer;
	margin-top: 3px;
}

.dia {
	width: 50%;
	margin-left: 50%;
	margin-top: -4.5%
}

.sp {
	height: 30px;
	border-bottom: 1px solid #ccc;
	margin-top: 10px;
	cursor: pointer;
	color: #169BD5;
}

.set_title_div {
	// border-bottom:2px solid white;
	padding-bottom: 3px;
	width: 79px;
	color: white;
	font-weight: bolder;
}

.conode {
	border: 1px solid #036EC2;
	margin-left: 15px;
	width: 97.1%;
	margin-top: 13px;
	border-radius: 0px 0px 7px 7px;
}

.setff {
	display: inline-block;
	margin-left: 27px;
}

.project-item {
  padding: 12px 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  border-bottom: 1px solid #e4e7ed;
  transition: background 0.2s;
}
</style>
